const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const MyInvitesSchema = (data) => {

    const schema = Joi.object({
        inviteEmail: Joi.string()
            .trim()
            .email({ tlds: { allow: false } }) // Validates as an email
            .messages({
                "string.email": currentLang?.ValidationSchema?.Valid_Email,
                "string.empty": currentLang?.ValidationSchema?.Email_Required,
                "any.required": currentLang?.ValidationSchema?.Email_Required,
            }),
        invitePhone: Joi.string()
            .pattern(/^\d{10}$/)
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Valid_Mobile,
                "string.empty": currentLang?.ValidationSchema?.Mobile_Required,
                "any.required": currentLang?.ValidationSchema?.Mobile_Required,
            }),
        inviteFirstName: Joi.string()
            .min(3)
            .required()
            .messages({
                "string.min": currentLang?.ValidationSchema?.Min_3Characters_Required,
                "string.empty": currentLang?.ValidationSchema?.First_Name_Required,
                "any.required": currentLang?.ValidationSchema?.First_Name_Required,
            }),
        invitelastName: Joi.string()
            .min(3)
            .required()
            .messages({
                "string.min": currentLang?.ValidationSchema?.Min_3Characters_Required,
                "string.empty": currentLang?.ValidationSchema?.Last_Name_Required,
                "any.required": currentLang?.ValidationSchema?.Last_Name_Required,
            }),
        inviterelationShip: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Relationship_required,
                "any.required": currentLang?.ValidationSchema?.Relationship_required,
            }),
    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = MyInvitesSchema;
